import { render, staticRenderFns } from "./PanelProject.vue?vue&type=template&id=5eae6355&"
import script from "./PanelProject.vue?vue&type=script&lang=js&"
export * from "./PanelProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports